import React, { PureComponent } from 'react';
import { compose } from 'redux';
import Helper from '../../helpers/Helper';
import {
  formatSelectedTags,
  normalizeSelectedTags,
  getOnlyCheckedProducts,
} from '../../helpers/products';
import withCategories from '../Categories';
import withCreateProductAddons from '../CreateProductsAddons';
import {
  PRODUCT_ADDONS,
  PRODUCT_ADDONS_TYPE,
  PRODUCT_VARIATION_ID_PREFIX,
  MAX_SELECTED_TAGS,
  PRODUCT_STATUS,
  HTTP_STATUS_CODE,
} from '../../helpers/constants';
import withProducts from '../Products';
import Storage from '../../helpers/storage';
import withTags from '../Tags';
import env from '../../config/env';
import { formatProductComboData, sortVariations, hasVariationsAddon } from '../../helpers/addons';
import withVariations from '../GlobalVariations';
import { priceToInt } from '../../helpers/price';

const INITIAL_STATE_ERRORS = {
  name: {
    isInvalid: false,
    message: null,
  },
  category: {
    isInvalid: false,
    message: null,
  },
  comboSteps: [],
};

const withCreateProduct = WrappedComponent => {
  class CreateProductContainer extends PureComponent {
    state = {
      data: {
        media: {
          imageBase64: '',
          contentType: '',
          extension: '',
          imageUrl: '',
        },
        imageFile: '',
        file: '',
        name: '',
        originalPrice: 0,
        category: null,
        sku: '',
        barcode: '',
        desc: '',
        tags: [],
      },
      errors: INITIAL_STATE_ERRORS,
      apiErrors: {
        errorTag: {},
        errorCategories: {},
      },
      showSubmitLoader: false,
      addonType: null,
    };

    async componentDidMount() {
      const { match, getProductById } = this.props;
      const { id } = match.params;
      this.handleGetCategories();
      this.handleGetTags();

      if (id) {
        const { data } = await getProductById(id);
        if (data) {
          this.injectProductDataInState(data);
        }
      }
    }

    componentWillUnmount() {
      const { clearAllSteps } = this.props;
      clearAllSteps();
    }

    setProductEditCategory = () => {
      const { productCategories } = this.props;
      const { data: stateData } = this.state;
      const data = { ...stateData };
      const { categories } = stateData;
      delete data.categories;

      this.setState(state => ({
        ...state,
        data: {
          ...data,
          category: categories
            ? productCategories.list.find(cat => cat.id === categories[0].id)
            : state.data.category,
        },
      }));
    };

    async setAddonTypes(product) {
      const { getAllProductsByStatus } = this.props;
      const addonType = product.productType;
      if (addonType === PRODUCT_ADDONS_TYPE.PRODUCTS) {
        await getAllProductsByStatus(1, true);
        this.setComboData(product);
      }
      if (addonType === PRODUCT_ADDONS_TYPE.VARIATIONS) {
        this.setProductVariationsData(product);
      }
    }

    setProductVariationsData = product => {
      const { setProductVariations } = this.props;
      const { productVariations, globalVariations } = product;
      let variations = [];
      if (productVariations && productVariations.length) {
        variations = productVariations.map(variation => ({
          ...variation,
          id: `${PRODUCT_VARIATION_ID_PREFIX}${variation.id}`,
        }));
      }

      if (globalVariations && globalVariations.length) {
        variations = [
          ...variations,
          ...globalVariations.map(variation => ({
            ...variation,
            isGlobal: true,
          })),
        ];
      }

      variations = sortVariations(variations);

      setProductVariations(variations);
    };

    setComboData(product) {
      const { setComboSteps, categories } = this.props;
      setComboSteps(formatProductComboData(product, categories));
    }

    removeUnecessaryData = data => {
      /* eslint-disable */
      delete data.image;
      delete data.merchantId;
      delete data.categories;
      delete data.globalVariations;
      delete data.comboProductSteps;
      delete data.productVariations;
      /* eslint-enable */
      return data;
    };

    handleGetTags = async () => {
      const { getTags } = this.props;
      let errorTag = {};
      const response = await getTags();
      const isRequestOk = [HTTP_STATUS_CODE.OK, HTTP_STATUS_CODE.NO_CONTENT].some(
        st => st === response.status
      );
      if (!response || !isRequestOk) {
        errorTag = {
          message:
            response && response.message
              ? response.message
              : 'Erro ao buscar tags, atualize a página',
        };
      }
      this.setState(state => ({
        ...state,
        apiErrors: {
          ...state.apiErrors,
          errorTag,
        },
      }));
    };

    handleGetCategories = async () => {
      const { getCategories } = this.props;
      let errorCategories = {};
      const response = await getCategories();
      const isRequestOk = [HTTP_STATUS_CODE.OK, HTTP_STATUS_CODE.NO_CONTENT].some(
        st => st === response.status
      );
      if (!response || !isRequestOk) {
        errorCategories = {
          message: response && response.message ? response.message : 'Erro. Atualize a página',
        };
      }
      this.setState(state => ({
        ...state,
        apiErrors: {
          ...state.apiErrors,
          errorCategories,
        },
      }));
    };

    onSubmit = () => {
      const { data } = this.state;
      const { editProduct, saveProduct } = this.props;
      const isValidForm = this.validateForm();
      if (isValidForm) {
        const formData = this.getFormData();

        // Salvar/Editar
        if (data.id) {
          editProduct(data.id, formData);
        } else {
          saveProduct(formData);
        }
      }
    };

    getFormData = () => {
      const { productCategories, productAddons, tags } = this.props;
      const { data, addonType } = this.state;

      const merchantId = Number(Storage.getLocalStorageMerchant().idUnity);

      let formData = {
        ...data,
        originalPrice: priceToInt(data.originalPrice),
        merchantId,
        status: PRODUCT_STATUS.ACTIVE,
        productType: PRODUCT_ADDONS_TYPE.VARIATIONS,
        image: {
          ...data.media,
          imageBase64: Helper.formatBase64ToSend(data.media.imageBase64),
        },
        categories: [
          {
            ...productCategories.list.find(cat => cat.id === data.category.id),
          },
        ],
        tags: formatSelectedTags(tags.list, data.tags),
      };

      delete formData.id;
      delete formData.imageFile;
      delete formData.file;
      delete formData.media;
      delete formData.category;

      // Products
      if (this.hasCombo()) {
        formData = {
          ...formData,
          productType: PRODUCT_ADDONS_TYPE.PRODUCTS,
          ...this.getComboData(),
        };
      }

      // Variations
      if (
        addonType === PRODUCT_ADDONS_TYPE.VARIATIONS &&
        productAddons.variations.list.length > 0
      ) {
        formData = {
          ...formData,
          productType: PRODUCT_ADDONS_TYPE.VARIATIONS,
          ...this.getVariationsData(),
        };
      }

      return formData;
    };

    getIndex = (list, id) => list.findIndex(item => item.id === id);

    getVariationsData = () => {
      const { productAddons } = this.props;
      const { list } = productAddons.variations;
      const data = {
        productVariations: list
          .filter(variation => !variation.isGlobal)
          .map(variation => this.formatVariationItemData(list, variation)),
        globalVariations: list
          .filter(variation => variation.isGlobal)
          .map(variation => this.formatVariationItemData(list, variation)),
      };

      return data;
    };

    formatVariationItemData = (list, variation) => {
      let newVariation = {
        ...variation,
        sortOrder: this.getIndex(list, variation.id),
      };

      if (!newVariation.isGlobal && !newVariation.isCreate) {
        newVariation = {
          ...newVariation,
          id: Helper.removeTextFromString(newVariation.id),
        };
      }

      if (newVariation.isCreate) {
        delete newVariation.id;
        delete newVariation.isCreate;
      }

      delete newVariation.isGlobal;

      return newVariation;
    };

    getComboData = () => {
      const { productAddons } = this.props;
      const productSteps = productAddons.steps.filter(
        step => step.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS && step.data
      );
      const globalVariationSteps = productAddons.steps.filter(
        step => step.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS && step.data
      );
      let comboData = {};

      if (productSteps.length) {
        comboData = {
          comboProductSteps: productSteps.map(step =>
            step.isEdit
              ? {
                  id: step.id,
                  name: step.title,
                  sortOrder: this.getIndex(productAddons.steps, step.id),
                  products: getOnlyCheckedProducts(step.data).map(prod => ({ id: prod.id })),
                }
              : {
                  name: step.title,
                  sortOrder: this.getIndex(productAddons.steps, step.id),
                  products: getOnlyCheckedProducts(step.data).map(prod => ({ id: prod.id })),
                }
          ),
        };
      }

      if (globalVariationSteps.length) {
        comboData = {
          ...comboData,
          globalVariations: globalVariationSteps.map(step => ({
            id: step.data.id,
            sortOrder: this.getIndex(productAddons.steps, step.id),
          })),
        };
      }

      return comboData;
    };

    hasCombo = () => {
      const { productAddons } = this.props;

      return productAddons.steps.length && productAddons.steps.some(step => step.data);
    };

    validateForm = () => {
      const { data } = this.state;
      const { name, category } = data;
      const { addonType } = this.state;
      const { productAddons } = this.props;
      let errors = { ...INITIAL_STATE_ERRORS };
      const isValidString = new RegExp(/\w+/g);

      if (!isValidString.test(name)) {
        errors = {
          ...errors,
          name: {
            isInvalid: true,
            message: 'Você precisa informar o nome do produto',
          },
        };
      } else if (!category || !Object.keys(category).length) {
        errors = {
          ...errors,
          category: {
            isInvalid: true,
            message: 'Você precisa selecionar a categoria do produto',
          },
        };
      } else if (
        addonType === PRODUCT_ADDONS_TYPE.PRODUCTS &&
        (this.hasEmptyComboStep() || this.hasEmptyComboStepTitle())
      ) {
        errors = {
          ...errors,
          comboSteps: productAddons.steps
            .filter(step => this.hasEmptyDataOrTitle(step))
            .map(step => ({
              id: step.id,
              isEmpty: !step.data,
              isTitleEmpty: step.data && !step.title,
            })),
        };
      }

      this.setState({ errors });

      return Object.keys(errors).every(key => !errors[key].isInvalid) && !errors.comboSteps.length;
    };

    hasEmptyComboStep = () => {
      const { productAddons } = this.props;
      return productAddons.steps.some(step => !step.data);
    };

    hasEmptyComboStepTitle = () => {
      const { productAddons } = this.props;
      return productAddons.steps.some(step => this.hasEmptyTitle(step));
    };

    hasEmptyDataOrTitle = step => !step.data || (step.data && this.hasEmptyTitle(step));

    hasEmptyTitle = step =>
      !step.title && step.addonType !== PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS;

    onChangeFile = ({ file, base64 }) => {
      const { data } = this.state;
      const extension = file ? file.name.split('.').reverse()[0] : null;
      this.setState({
        data: {
          ...data,
          file,
          media: {
            ...data.media,
            contentType: file ? file.type : null,
            imageBase64: !file ? '' : base64,
            extension,
            imageUrl: '',
          },
        },
      });
    };

    handleChange = e => {
      const { data } = this.state;
      this.setState({
        data: {
          ...data,
          [e.target.name]: e.target.value,
        },
      });
    };

    handleChangePrice = (e, value) => {
      this.setState(state => ({
        data: {
          ...state.data,
          [e.target.name]: value,
        },
      }));
    };

    handleSelectCategory = value =>
      this.setState(state => ({
        data: {
          ...state.data,
          category: value,
        },
      }));

    closeModal = error => {
      const { finishSubmitProduct, history } = this.props;
      finishSubmitProduct();
      if (!error) {
        history.push('/admin/products');
      }
    };

    onSelectAddonType = type => this.setState({ addonType: type });

    clearAddonType = () => this.setState({ addonType: null });

    getError = () => {
      const { errors } = this.state;
      const errorIndex = Object.keys(errors).find(
        key => errors[key].isInvalid || errors[key].isInvalidQtd
      );

      if (!errorIndex) {
        if (errors.comboSteps.length) {
          return {
            isInvalid: true,
            message: errors.comboSteps[0].isEmpty
              ? 'Existem passos em branco, você precisa preenchê-los ou excluí-los para prosseguir'
              : 'Você precisa preencher o título dos passos para prosseguir',
          };
        }
      }

      return errorIndex ? errors[errorIndex] : {};
    };

    isLoadingEdit = () => {
      const { data } = this.state;
      const { isLoadingProducts, isLoadingProduct } = this.props;
      if (data.id) {
        if (data.productType === PRODUCT_ADDONS_TYPE.PRODUCTS) {
          return isLoadingProduct || isLoadingProducts;
        }
        if (data.productType === PRODUCT_ADDONS_TYPE.VARIATIONS) {
          return isLoadingProduct;
        }
      }
      return isLoadingProduct;
    };

    getSelectedTags = id => {
      const { data } = this.state;
      const isSelected = data.tags.some(tag => tag === id);
      const canAddMoreTags = data.tags.length < MAX_SELECTED_TAGS;
      let { tags } = data;
      if (isSelected) {
        tags = data.tags.filter(tag => tag !== id);
      } else if (canAddMoreTags) {
        tags = [...data.tags, id];
      }

      return tags;
    };

    toggleTag = id => {
      this.setState(state => ({
        ...state,
        data: {
          ...state.data,
          tags: this.getSelectedTags(id),
        },
      }));
    };

    setAddonType = (addonType, data) => {
      let type = null;

      if (addonType === PRODUCT_ADDONS_TYPE.PRODUCTS) {
        type = PRODUCT_ADDONS_TYPE.PRODUCTS;
      } else if (hasVariationsAddon(data)) {
        type = PRODUCT_ADDONS_TYPE.VARIATIONS;
      }

      return type;
    };

    async injectProductDataInState(data) {
      const { data: stateData } = this.state;
      const category = data.categories[0];
      const formattedData = this.removeUnecessaryData({ ...data });
      const addonType = data.productType;

      this.setProductEditCategory();
      this.setState({
        data: {
          ...formattedData,
          media: {
            ...stateData.media,
            imageUrl: data.image.imageUrl,
            imageBase64: data.image.imageUrl
              ? `${env.REACT_APP_BASE_IMG}${data.image.imageUrl}`
              : '',
          },
          category: {
            id: category.id,
            label: category.name,
            value: category.id,
          },
          tags: normalizeSelectedTags(formattedData.tags),
        },
        addonType: this.setAddonType(addonType, data),
      });

      this.setAddonTypes(data);
    }

    render() {
      const { isLoadingSubmitProduct, isSubmitProductFinished } = this.props;
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          toggleTag={this.toggleTag}
          closeFormModal={() => this.closeModal(false)}
          closeFormErrorModal={() => this.closeModal(true)}
          handleSelectCategory={this.handleSelectCategory}
          handleChangePrice={this.handleChangePrice}
          handleChange={this.handleChange}
          isLoadingEdit={this.isLoadingEdit}
          onChangeFile={this.onChangeFile}
          onSelectAddonType={this.onSelectAddonType}
          clearAddonType={this.clearAddonType}
          onSubmit={this.onSubmit}
          getError={this.getError}
          isSubmitting={isLoadingSubmitProduct}
          showSubmitLoader={isLoadingSubmitProduct || isSubmitProductFinished}
        />
      );
    }
  }

  return compose(
    withCategories,
    withCreateProductAddons,
    withProducts,
    withTags,
    withVariations
  )(CreateProductContainer);
};

export default withCreateProduct;



// WEBPACK FOOTER //
// ./src/containers/CreateProduct/index.js